import React from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { appInsights } from 'Core_Helpers/AppInsights';
import PropTypes from 'prop-types';
import { Tab } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import { PROFILE } from 'Core_Pages/Routes/RoutesConfig';

const ProfileNavbarItem = ({ onClick, ...props }) => {
  const history = useHistory();
  const intl = useIntl();

  const { selected } = props;

  const onNavItemClick = (event) => {
    onClick(event);
    history.push(PROFILE);
    appInsights.trackEvent({ name: 'Profile_Clicked' });
  };

  const Icon = selected ? PersonIcon : PersonOutlinedIcon;

  return (
    <>
      <Tab
        {...props}
        icon={<Icon aria-hidden="true" />}
        label={intl.formatMessage({ id: 'menu-header.profile' })}
        href={PROFILE}
        aria-current={selected}
        onClick={onNavItemClick}
      />
    </>
  );
};

ProfileNavbarItem.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
};

export default ProfileNavbarItem;
